// :cow: Cosmose CONFIDENTIAL :iso:
import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '../config/environmentConfig';

export const APP_CONFIG = new InjectionToken<EnvironmentConfig>('config');
